module.exports = __webpack_public_path__ + "static/media/savio15.e6089ba6.jpg";